import dynamic from "next/dynamic";
const AnimatedIconsGridComponent = dynamic(()=>import("./animated-icons-grid-component"));
import AnimatedIconsGridConfig from "./animated-icons-grid-config";
import AnimatedIconsGridAdvancedConfig from "./animated-icons-grid-advanced-config";
export default {
    AnimatedIconsGridComponent,
    AnimatedIconsGridConfig,
    AnimatedIconsGridAdvancedConfig
};
